import { lazy } from "react";

// Manual GST (R1-3B payment request) — kept in its own route file so it stays
// separate from the GSTR-1 / GSTR-3B console routes in gstRoutes.js.
const ManualGST = lazy(() => import("../Component/GST/ManualGST/ManualGST"));

const manualGstRoutes = [
  { path: "/manual-gst", element: <ManualGST />, protected: true },
];

export default manualGstRoutes;
